package com.cybergstudios.rtc.world

import com.cybergstudios.rtc.engine.Color
import com.cybergstudios.rtc.engine.GameState
import com.cybergstudios.rtc.math.Vec2
import kotlin.math.max
import kotlin.math.min

data class Paddle(
    var x: Double, // left position
    var y: Double, // top position
    var width: Double,
    var height: Double,
    val color: Color,
    // x values are in the range [-10, 10]
    var vel: Vec2 = Vec2(0.0, 0.0),
    var velIncr: Double = 0.1,
    var velMaxPos: Double = 1.0,
    var velMaxNeg: Double = -1.0,
    var ticksCoolDown: Int = 0
) {
    companion object {
        fun newPaddlePlayer(): Paddle =
            Paddle(-50.0, -350.0, 100.0, 10.0, Color(13.0, 213.0, 252.0, 1.0))

        fun newPaddleOpponent(): Paddle =
            Paddle(-50.0, 360.0, 100.0, 10.0, Color(204.0, 0.0, 0.0, 1.0))
    }

    // Increase velocity to the left
    fun moveLeft() {
        val x = this.vel.x - this.velIncr
        this.vel = Vec2(max(x, this.velMaxNeg), this.vel.y)
    }

    // Increase velocity to the right.
    fun moveRight() {
        val x = this.vel.x + this.velIncr
        this.vel = Vec2(min(x,  this.velMaxPos), this.vel.y)
    }

    fun integrate(delta: Double) {
        val curPos = Vec2(x, y)
        val newPos = curPos.add(this.vel.scale(delta))
        this.x = newPos.x
        this.y = newPos.y
    }

    fun leftWallHit(state: GameState) {
        x = state.canvasDimension.borderMinX
        vel = Vec2(0.0, 0.0)
    }

    fun rightWallHit(state: GameState) {
        x = state.canvasDimension.borderMaxX - width
        vel = Vec2(0.0, 0.0)
    }

    fun xCenter(): Double = (width / 2) + x
}
